import React from 'react';
import { Download } from 'lucide-react';

const CTA = () => {
  return (
    <section className="py-20 px-4">
      <div className="max-w-6xl mx-auto bg-[#0a0f1c] rounded-[2.5rem] overflow-hidden flex flex-col md:flex-row items-center border border-white/5">
        <div className="p-12 md:p-20 flex-1">
          <span className="bg-blue-600 text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase">Gratuit</span>
          <h2 className="text-4xl font-bold text-white mt-6 mb-6">Le Guide Ultime de la Cybersécurité pour les PME</h2>
          <p className="text-gray-400 mb-10 leading-relaxed">Apprenez les 10 gestes essentiels pour sécuriser votre entreprise contre 80% des cyberattaques courantes.</p>
          <button className="flex items-center gap-3 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold transition">
            <Download size={20} />
            Télécharger l'Ebook
          </button>
        </div>
        <div className="flex-1 p-12 bg-gradient-to-br from-blue-900/20 to-transparent w-full h-full flex justify-center">
           <div className="w-64 h-80 bg-white/10 rounded-lg border border-white/20 shadow-2xl backdrop-blur-sm flex items-center justify-center text-white/20 text-center p-4">
             [Visuel Ebook]
           </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;